<template>
    <div class="data-item animated slideInUp" v-cloak>
      <p class="data-item-title">{{ title }}</p>
      <!-- :style="{color:state == true ? 'red' : 'black'}" -->
      <p class="data-item-msg" :style="{textAlign: type == 'center' ? 'center':'left'}">{{ sub }}</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "DataItem",
    props:{//props列表
        sub:String,
        title:String,
        type: String
    },
    data() {
      return {

      };
    },
    mounted() {
    },
    methods: {
    }
  };
  </script>
  <style scoped>
  .data-item{
    box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 20%);
    width: 30%;
    padding: 30px 20px;
    margin-right: 3%;
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
  }
  .data-item-title{
    font-size: 20px;
    text-align: center;
    transition: all 0.3s;
    margin-bottom: 20px;
    font-weight: bold;
  }
  .data-item:hover .data-item-title{
    color: #009DE4;
  }
  .data-item-msg{
    font-size: 14px;
    line-height: 2;
    color: #666;
  }
  .animated {
    animation-duration: 1.5s;
    animation-fill-mode: both;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/dataItem.vue